import type { ReactNode } from "react";
import type { TableCellProps } from "@mui/material";
import { Skeleton, TableCell, TableRow, Typography } from "@mui/material";
import { rangeUtil } from "utils/rangeUtil";

function TableCellSkeleton(props: Readonly<TableCellProps>): ReactNode {
  return (
    <TableCell {...props}>
      <Typography>
        <Skeleton />
      </Typography>
    </TableCell>
  );
}

function TriByArticleLineSkeleton(): ReactNode {
  return (
    <TableRow sx={{ ".MuiTableCell-root": { paddingX: 1 } }}>
      {rangeUtil.arrayRange(6).map((i) => (
        <TableCellSkeleton key={i} />
      ))}
      <TableCellSkeleton sx={{ "&.MuiTableCell-root": { width: "375px" } }} />
      <TableCell sx={{ width: "46px" }}></TableCell>
    </TableRow>
  );
}
export default TriByArticleLineSkeleton;
